import React, { useState } from 'react';
import FreeTrial from '../../Components/about-page/free-trial';
import { Footer } from '../../Components/Footer';
import HeroContainer from '../../Components/ui/hero-container';
import Button from '../../Components/ui/button/Button';
import FeatureInfoCard from '../../Components/FeatureInfoCard';
import { StandardizedTestingData } from './data/StandardizedTestingData';
import HeaderAlt from '../../Components/HeaderAlt';
import CustomModal from '../../Components/CustomModal';
import SignUpPopup from '../tutor-details/components/SignupPopup';

const StandardizedTesting = () => {
  const [showSignupModal, setShowSignupModal] = useState(false);
  return (
    <>
      <HeaderAlt />
      <div className="flex-container relative">
        <HeroContainer className="flex pb-[60px] pt-[40px] md:pb-[59px]">
          <div className="container flex flex-col gap-6 !px-6 md:flex-row md:justify-between md:gap-20">
            <div className="max-w-[574px] space-y-4 !pt-2 text-left md:space-y-6">
              <p className="!mb-4 text-center text-base font-medium uppercase tracking-[1.28px] text-[#66CDCC] md:text-left">
                Standardized Testing
              </p>
              <h1 className="fredokaOne w-full text-center text-[40px] font-normal  leading-tight tracking-[-0.8px] text-white md:text-left md:!text-[56px] md:tracking-[-1.12px]">
                Smarter ACT & SAT Prep with AI-Powered Tools
              </h1>
              <p className="fredoka max-w-2xl text-center text-[18px] font-medium leading-[144.44%] tracking-[-0.18px] text-[#678285] md:text-left md:text-[22px] md:leading-[32px] md:tracking-[-0.22px]">
                Ace the ACT & SAT with AI-driven, gamified learning and real-time insights for a
                smarter, personalized study plan.
              </p>
              <div className="w-full pt-2 md:w-fit">
                <Button onClick={() => setShowSignupModal(true)} label={'Get Started'} />
              </div>
            </div>
            <div className="absolute right-0 hidden md:block">
              <img
                src="/images/standardized-testing/standardized-testing-hero.png"
                alt="hero-img"
                className="block"
              />
            </div>
          </div>
        </HeroContainer>

        <div className="container !mt-5 flex flex-col gap-4  md:!mt-16 ">
          {StandardizedTestingData.map((data, index) => (
            <FeatureInfoCard key={index} data={data} />
          ))}
        </div>

        <div className="container !my-14">
          <FreeTrial />
        </div>
        <Footer />
      </div>
      <CustomModal
        className="max-w-[480px]"
        isOpen={showSignupModal}
        onClose={() => setShowSignupModal(false)}
      >
        <SignUpPopup />
      </CustomModal>
    </>
  );
};

export default StandardizedTesting;
